/**
 * Asynchronously loads the component for ExplorePage
 */

import React from 'react'
import loadable from 'utils/Loadable'
import { LoadingPage } from 'components/Loading'

export default loadable(() => import(/* webpackChunkName: "ExplorePage" */ './index'), {
  fallback: <LoadingPage delay={1} />
})
